import { createFileRoute } from "@tanstack/react-router";
import PrTmsPage from "@/pages/PrTmsPage";
export const Route = createFileRoute("/prtms-therapy-coral-springs-fl")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title:
            "PrTMS Personalized TMS Therapy Coral Springs FL | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "Personalized Repetitive Transcranial Magnetic Stimulation in Coral Springs FL. EEG-guided brain wave optimization for Autism, ADHD, depression & PTSD.",
        },
        {
          property: "og:title",
          content:
            "PrTMS Personalized TMS Therapy Coral Springs FL | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "Personalized Repetitive Transcranial Magnetic Stimulation in Coral Springs FL. EEG-guided brain wave optimization for Autism, ADHD, depression & PTSD.",
        },
        {
          property: "og:url",
          content:
            "https://neurowellnesstms.com/prtms-therapy-coral-springs-fl",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/prtms-therapy-coral-springs-fl",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <PrTmsPage />;
}
